import React from "react"
import HousekeepingLog from "../HousekeepingLog/HousekeepingLog"

class FixHousekeepingLog extends React.Component{

  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div>
        <HousekeepingLog 
          onSuccess={this.touchSystemNotification} 
          history_visible={this.props.history_visible}
          assigned_to={this.props.assigned_to}
          customer={this.props.customer}
          date_format={this.props.date_format}
          default_housekeeper={this.props.default_housekeeper}
          finished_at={this.props.finished_at}
          flagged={this.props.flagged}
          housekeeping_log_revision_history_path={this.props.housekeeping_log_revision_history_path}
          id={this.props.id}
          image_group={this.props.image_group}
          new_record={this.props.new_record}
          reservation={this.props.reservation}
          reservation_segment={this.props.reservation_segment}
          room={this.props.room}
          room_type={this.props.room_type}
          notes={this.props.notes}
          scheduled_at={this.props.scheduled_at}
          started_at={this.props.started_at}
          status={this.props.status}
          time_format={this.props.time_format}
        />
      </div>
    );
  }

  touchSystemNotification(msg) {
    var self = this;

    if (msg && top.successGrowl) {
      top.successGrowl(msg);
    }

    if (top.touchSystemNotification) {
      top.touchSystemNotification(this.props.system_notification.id);
    }
  }
};

export default FixHousekeepingLog